import { useEffect, useState } from 'react'

//api
import { getPasskeySettingsForOrg, setPasskeySettingsForOrg } from '@/api/orgSettings/passkeys';

//interfaces
import { IUserCountInfo } from  '@/interfaces/passkeys';
import { NotificationStatus } from  '@/interfaces/languages';

//hooks and helpers
import { useTimer } from  '@/components/hooks/utility/useTimer';



const UsePasskeySettingsScreen = (orgId: string) => {  
    const [showModal, setShowModal]=useState<boolean>(false);
    const [isLoading, setIsLoading]=useState<boolean>(true);
    const [confirmationFlow, setConfirmationFlow]=useState<boolean>(false);
    const [showConfirmationModal, setShowConfirmationModal]=useState<boolean>(false);
    const [passkeysEnabled, setPasskeysEnabled] = useState<boolean>(false);
    const [restrictedAccess, setRestrictedAccess] = useState<boolean>(false);
    const [forcePasskeySignIn, setForcePasskeySignIn] = useState<boolean>(false);
    const [notificationDetails, setNotificationDetails] = useState<{show: boolean, status: NotificationStatus | null, message: string}>();
    const [userCountInfo, setUserCountInfo] = useState<IUserCountInfo>({"usersWithPasskeys": 0, "totalEligibleUsers": 0, "passkeyAdoptionPercentage": 0, "legacyAppUserCount": 0});

    useEffect(() => {
        getPasskeySettings();
    },[]);


    function getPasskeySettings() {
        getPasskeySettingsForOrg(orgId)
        .then((data) => {
            setUserCountInfo({
                usersWithPasskeys:  data.passkeyAdoptionStats.usersWithPasskeys,
                totalEligibleUsers: data.passkeyAdoptionStats.totalEligibleUsers, 
                passkeyAdoptionPercentage: data.passkeyAdoptionStats.passkeyAdoptionPercentage,
                legacyAppUserCount: data.legacyAppUserCount
            });

            setConfirmationFlow(!data.passkeySignInEnabled);
            setForcePasskeySignIn(data.forcePasskeySetupEnabled);
            setPasskeysEnabled(data.passkeySignInEnabled);
            setRestrictedAccess(false);
        })
        .catch((error: { status: number; }) => {
            if (error.status === 403) {
                setRestrictedAccess(true);
            } else if (error.status === 404) {
                window.location.href = `../error404`
            } else {
                setNotificationDetails({show: true, status: NotificationStatus.error, message: "Something went wrong. Please try again."});
            }
        })
        .finally(()=> {
            setIsLoading(false);
        });
    }

    function savePasskeySettings() {        
        setPasskeySettingsForOrg(orgId, passkeysEnabled, forcePasskeySignIn)
        .then(() => {
            setNotificationDetails({show: true, status: NotificationStatus.success, message: "Passkey settings updated (The browser will now refresh to allow these settings to take effect)"});
        })
        .catch(() => {
            setNotificationDetails({show: true, status: NotificationStatus.error, message: "Something went wrong. Please try again."});
        })
        .finally(() => {
            getPasskeySettings();
        })
    }

    function onSaveChangesClick(hasConfirmed: boolean) {
        if (confirmationFlow && !hasConfirmed && passkeysEnabled) {
            setShowConfirmationModal(true);
        } else {
            setConfirmationFlow(false);
            setShowConfirmationModal(false);
            savePasskeySettings();
        }
    }

    function onEnablePasskeysClick() {
        if (passkeysEnabled) {
            setForcePasskeySignIn(false);
        }
        setPasskeysEnabled(!passkeysEnabled);
    }

    function closeToast() {
        setNotificationDetails({show: false, status:null, message: ""})
    }

    return{
        isLoading,
        showModal, 
        setShowModal, 
        userCountInfo, 
        forcePasskeySignIn, 
        setForcePasskeySignIn, 
        setPasskeysEnabled, 
        passkeysEnabled, 
        onSaveChangesClick, 
        onEnablePasskeysClick, 
        showConfirmationModal, 
        setShowConfirmationModal, 
        restrictedAccess, 
        notificationDetails,
        closeToast
    }
}

export default UsePasskeySettingsScreen